"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get InternalApiModuleProvider () {
        return InternalApiModuleProvider;
    },
    get InternalApiModules () {
        return InternalApiModules;
    }
});
const _RecordAuditListoperations = require("~/controllers/internal/modules/RecordAuditList.operations");
const _McpGetoperations = require("~/controllers/internal/modules/McpGet.operations");
const _McpPostoperations = require("~/controllers/internal/modules/McpPost.operations");
const _OAuthGetoperations = require("~/controllers/internal/modules/OAuthGet.operations");
const _OAuthPostoperations = require("~/controllers/internal/modules/OAuthPost.operations");
const _DependencyPostoperations = require("~/controllers/internal/modules/DependencyPost.operations");
const _UiGetoperations = require("~/controllers/internal/modules/UiGet.operations");
const _UiPostoperations = require("~/controllers/internal/modules/UiPost.operations");
const _BaseListAllGetoperations = require("~/controllers/internal/modules/BaseListAllGet.operations");
const _internaltype = require("~/utils/internal-type");
const InternalApiModules = [
    _McpGetoperations.McpGetOperations,
    _McpPostoperations.McpPostOperations,
    _OAuthGetoperations.OAuthGetOperations,
    _OAuthPostoperations.OAuthPostOperations,
    _RecordAuditListoperations.RecordAuditListOperations,
    _DependencyPostoperations.DependencyPostOperations,
    _UiGetoperations.UiGetOperations,
    _UiPostoperations.UiPostOperations,
    _BaseListAllGetoperations.BaseListAllGetOperations
];
const InternalApiModuleProvider = {
    provide: _internaltype.INTERNAL_API_MODULE_PROVIDER_KEY,
    useFactory: (...internalApiModules)=>internalApiModules,
    inject: InternalApiModules
};
